import React from 'react';

class CustomTable extends React.Component {
    constructor(props) {
        super(props);
        this.headList = this.props.headList
        this.bodyList = this.props.bodyList
        this.imageWidth = this.props.imageWidth
        this.imageHeight = this.props.imageHeight
        this.itemsPerPage = this.props.itemsPerPage
        this.rowNumber = this.props.rowNumber
        this.pagination = this.props.pagination
        this.numberOfPages = null

        this.state = {
            currentPage: 1,
        }
    }
    componentDidUpdate() {
        if (this.bodyList.length !== this.props.bodyList.length) {
            this.bodyList = this.props.bodyList
            this.forceUpdate()
        }
    }

    nextPage() {
        if (this.state.currentPage < this.numberOfPages) {
            this.setState({ currentPage: this.state.currentPage + 1 })
        }
    }
    previousPage() {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 })
        }
    }
    render() {
        const imageWidth = this.imageWidth === undefined ? null : this.imageWidth
        const imageHeight = this.imageHeight === undefined ? null : this.imageHeight
        const itemsPerPage = this.itemsPerPage === undefined ? 10 : this.itemsPerPage
        const rowNumber = this.rowNumber === undefined ? false : this.rowNumber
        const pagination = this.pagination === undefined ? false : this.pagination
        const numberOfPages = Math.ceil(this.bodyList.length / itemsPerPage)
        this.numberOfPages = numberOfPages

        let startingRow = this.pagination === true ? (this.state.currentPage - 1) * itemsPerPage : 0
        let endingRow = this.pagination === true ? this.state.currentPage * itemsPerPage : this.bodyList.length
        return (
            <div>
                <table className="table">
                    <thead className="text-primary">
                        <tr>
                            {
                                //Displays row number column
                                rowNumber &&
                                <th>#</th>
                            }
                            {
                                this.headList.map((value, index) => {
                                    return (
                                        <th key={index}>{value}</th>
                                    )
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {this.bodyList.slice(startingRow, endingRow).map((value, index) => {
                            let keys = Object.keys(value)
                            return (
                                <tr key={index}>
                                    {
                                        //Displays row number
                                        rowNumber &&
                                        <td>{index + 1}</td>
                                    }

                                    {keys.map((element, index) => {
                                        const myArray = value[element].split(".");
                                        let lastElem = myArray[myArray.length - 1]
                                        //Check if the data is an image path, if it is, we display img tag inside the td tag
                                        if (lastElem === "jpg" || lastElem === "png" || lastElem === "jpeg" || lastElem === "gif") {
                                            return (
                                                < td key={index} ><img alt="logo" src={"https://admin.mydzstore.com/" + value[element]} style={{ width: imageHeight, height: imageWidth }}></img></td>
                                            )
                                        } else {
                                            return (
                                                <td key={index}>{value[element]}</td>
                                            )
                                        }
                                    })}
                                </tr>)
                        })}
                    </tbody>

                    {
                        pagination &&
                        <nav aria-label="Page navigation example">
                            <ul class="pagination">
                                <li class="page-item"><a class="page-link" href="#" onClick={() => this.previousPage()}>Previous</a></li>
                                <li class="page-item"><a class="page-link" href="#">{this.state.currentPage + " / " + numberOfPages}</a></li>
                                <li class="page-item"><a class="page-link" href="#" onClick={() => this.nextPage()}>Next</a></li>
                            </ul>
                        </nav>
                    }

                </table>
            </div >
        );
    }
}

export default CustomTable;
